import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f22b4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "main-content" }
const _hoisted_5 = { class: "row pt-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-sm-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/home/intro-1.jpg",
    class: "img-fluid kometa-image-rounded",
    alt: "Kometa"
  })
], -1))
const _hoisted_7 = { class: "col-md-6 col-sm-12" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<h2 class=\"h2\" data-v-0f22b4a8> Stejnost, <span class=\"kometa-highlight\" data-v-0f22b4a8>jednotnost,</span> přesnost, <span class=\"kometa-highlight\" data-v-0f22b4a8>disciplína, ale také</span> podpora, <span class=\"kometa-highlight\" data-v-0f22b4a8>důvěra a</span> součást života </h2><p class=\"kometa-pre-text\" data-v-0f22b4a8> Těmito slovy popisuje náš současný juniorský tým, co pro něj znamená “Synchro”. </p><p data-v-0f22b4a8> Už od roku 2002 se věnujeme v oddíle USK Praha výchově krasobruslařek se zaměřením na synchronizované bruslení od prvních krůčků na ledě až po seniorskou kategorii. Někteří bruslaři tak spolu vyrůstají od přípravného kurzu. Další se přidávají z řad bývalých či stále aktivních bruslařů do závodních týmů. </p>", 3)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Více o nás ")
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2 w-100 text-center" }, "Naše týmy")
], -1))
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2 w-100 text-center" }, "Náš trenérský tým")
], -1))
const _hoisted_17 = { class: "col-12 text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/couch/coach-photo.jpg",
  class: "w-100 mb-4 kometa-image-rounded",
  alt: "Trenérský tým Kometa"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Více o trenérském týmu ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_carousel = _resolveComponent("home-carousel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_home_carousel, {
          id: "showCase",
          images: _ctx.showCaseImages
        }, null, 8, ["images"])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", null, [
            _createVNode(_component_router_link, {
              to: { name: 'aboutUs' },
              class: "btn kometa-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-6 col-sm-12 mb-4 text-center team-box",
            style: _normalizeStyle(`color: ${team.barva}`),
            key: team.id
          }, [
            _createVNode(_component_router_link, {
              to: { name: 'teams', params: { teamId: team.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: team.obrazekUpoutavky,
                  class: "img-fluid kometa-image-rounded",
                  alt: team.jmeno
                }, null, 8, _hoisted_14),
                _createElementVNode("p", {
                  class: "mt-4 team-box-title",
                  style: _normalizeStyle(`background-color: ${team.barva}`)
                }, _toDisplayString(team.jmeno), 5)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_router_link, {
            to: { name: 'coachTeam' },
            class: "btn btn-lg kometa-btn mb-4"
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}